/* eslint-disable no-undef */
import WPClient from '@/services/wpClient';
import useWPUrls from '@/composables/useWPUrls';
export default function useWPClient() {
  const wpUrls = useWPUrls();
  const {
    WP_REST
  } = storeToRefs(wpUrls);
  return new WPClient(WP_REST.value);
}